import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wh4df8t9g6: FaireBrandEntity = {
  token: "b_wh4df8t9g6",
  type: "brand",
  name: "Triciclo Editores",
  avatarUrl:
    "https://cdn.faire.com/fastly/7ca56edc6d31372eafabb077587f7eff90415e823444cf8baf180a5d23d97041.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/237173380e69e9ce6df5a3e60e47c1378a16f0e27e23a89cdbfd302c1f8c5c97.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7ca56edc6d31372eafabb077587f7eff90415e823444cf8baf180a5d23d97041.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/237173380e69e9ce6df5a3e60e47c1378a16f0e27e23a89cdbfd302c1f8c5c97.jpeg",
  location: "ESP",
  minimumOrderDollars: 109,
  rating: 3.9,
  reviewCount: 8,
  isInsider: false,
  description:
    "Triciclo Editores is a Spanish publishing house based in Madrid, specializing in the creation and commercialization of entertainment and hobby collectibles, mostly distributed at newsstands.\n\nIn recent years, we have focused on children's products and are achieving great success with the sale of surprise packs of fun products, thanks to partnerships with the brands Sbabam and Cicaboom.\n\nAdditionally, we continue to market our classic lines of lead soldier figures and miniatures, and each year we create new groups of figures for our series El Belén, designed by José Luis Mayo.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:58.337Z",
    importedBy: "entity-db-cli",
  },
};
